<template>
<div class="account-bar">
<!--先不考虑赠金活动 todo-->
  <div class="bar-left">
    <div class="left-top">
      <span
        class="login-num"
      >{{accountInfo.alias || accountInfo.login}}</span>
      <div
        class="real-tag tag theme-color" :style="themeOpacty">{{getAccountType(accountInfo,this)}}</div>
      <div class="mt4-tag tag">MT4</div>
    </div>
    <div
      class="pc-left-bot left-bot hidden-xs-only">
      <span>
        <span class="text">{{$t('transaction_account')}}:</span>
        <span class="data">
          {{accountInfo.login}}
          <i
            class="iconfont icon-copy1 pointer"
            @click="copyHandle(accountInfo.login)"
          ></i>
        </span>
      </span>
      <el-divider direction="vertical"></el-divider>
      <span>
        <span class="text">{{$t('server')}}:</span>
        <span class="data">
          {{accountInfo.serverName}}
          <i
            class="iconfont icon-copy1 pointer"
            @click="copyHandle(accountInfo.serverName)"
          ></i>
        </span>
      </span>
      <el-divider direction="vertical"></el-divider>
      <span>
        <span class="text">{{$t('Group')}}:</span>
        <span class="data">
          {{accountInfo.accType}}
        </span>
      </span>
      <el-divider direction="vertical"></el-divider>
      <span>
        <span class="text">{{$t('User.forexLeverage')}}<el-tooltip class="item" popper-class="maxwidthtooltips" effect="dark" :content="$t('User.accountCardTips1')" placement="top">
            <i class="el-icon-info icon-el iconcolor"></i>
          </el-tooltip>:</span>
        <span class="data">
          1:{{accountInfo.leverage}}
          
        </span>
      </span>
      <el-divider direction="vertical"></el-divider>
      <span>
        <span class="text">{{$t('User.preciousMetalLeverage')}}
          <el-tooltip class="item" popper-class="maxwidthtooltips" effect="dark" :content="$t('User.accountCardTips2')" placement="top">
            <i class="el-icon-info icon-el iconcolor"></i>
          </el-tooltip>:</span>
        <span class="data" v-if="accountInfo.businessType != 5">
          1:{{accountInfo.preciousMetalLeverage||accountInfo.preciousMetalLeverage == 0?accountInfo.preciousMetalLeverage:""}}
        </span>
        <span class="data" v-else>
          1:100
        </span>
      </span>
      <el-divider direction="vertical"></el-divider>
       <br>
      <span>
        <span class="text">{{$t('User.liquidationRatio')}}<el-tooltip class="item" popper-class="maxwidthtooltips" effect="dark" :content="$t('User.accountCardTips3')" placement="top">
            <i class="el-icon-info icon-el iconcolor"></i>
          </el-tooltip>:</span>
        <span class="data" v-if="accountInfo.businessType != 5">
          {{accountInfo.forceClosedRate||accountInfo.forceClosedRate == 0?accountInfo.forceClosedRate+'%':""}}
        </span>
         <span class="data" v-else>
          100%
        </span>
      </span>
      <el-divider direction="vertical"></el-divider>
      <span>
        <span class="text">{{$t('User.collateralMarginRatio')}}<el-tooltip class="item" popper-class="maxwidthtooltips" effect="dark" :content="$t('User.accountCardTips4')" placement="top">
            <i class="el-icon-info icon-el iconcolor"></i>
          </el-tooltip>:</span>
        <span class="data" v-if="accountInfo.businessType != 5">
          {{accountInfo.lockedMarginRate||accountInfo.lockedMarginRate == 0?accountInfo.lockedMarginRate+'%':""}}
        </span>
        <span class="data" v-else>
          50%
        </span>
      </span>




      <el-divider direction="vertical"></el-divider>
      <span>
        <span class="text">{{$t('equity')}}:</span>
        <span class="data">
          {{accountInfo.equity}}{{currency}}
        </span>
      </span>
      <el-divider direction="vertical"></el-divider>
      <span>
        <span class="text">{{$t('balance')}}:</span>
        <span class="data">
          {{accountInfo.balance}}{{currency}}
        </span>
      </span>
      <el-divider direction="vertical"></el-divider>

      <span>
        <span class="text">{{$t('credit_amount')}}:</span>
        <span class="data">
          {{accountInfo.credit}}{{currency}}
        </span>
      </span>

      <el-divider direction="vertical"></el-divider>
      <span>
        <span class="text">
          {{$t('state')}}:
        </span>
        <span class="data">
          <mt4-status
            class="mt4-status"
            :account-info="accountInfo"
          ></mt4-status>
        </span>
      </span>
    </div>
    <el-row :gutter="10">
      <el-col :span="12" class="xs-line">
        <span class="text">{{$t('transaction_account')}}:</span>
        <span class="data">
          {{accountInfo.login}}
        </span>
      </el-col>
      <el-col :span="12" class="xs-line">
        <span class="text">{{$t('server')}}:</span>
        <span class="data">
          {{accountInfo.serverName}}
        </span>
      </el-col>
      <el-col :span="12" class="xs-line">
          <span class="text">
            {{$t('Group')}}:
          </span>
        <span class="data">
            {{accountInfo.accType}}
          </span>
      </el-col>
      
      <el-col :span="12" class="xs-line">
        <span class="text">{{$t('equity')}}:</span>
        <span class="data">
          {{accountInfo.equity}}
        </span>
      </el-col>
      <el-col :span="12" class="xs-line">
        <span class="text">{{$t('balance')}}:</span>
        <span class="data">
          {{accountInfo.balance}}
        </span>

      </el-col>
      <el-col :span="12" class="xs-line">
        <span class="text">{{$t('credit_amount')}}:</span>
        <span class="data">
          {{accountInfo.credit}}
        </span>
      </el-col>


      
      <el-col :span="24" class="xs-line">
        <span class="text">{{$t('User.forexLeverage')}}<el-tooltip popper-class="maxwidthtooltips" class="item" effect="dark" :content="$t('User.accountCardTips1')" placement="top">
          <i class="el-icon-info icon-el iconcolor"></i>
        </el-tooltip>:</span>
        <span class="data">
          1:{{accountInfo.leverage}}
        </span>
      </el-col>
      <el-col :span="24" class="xs-line">
        <span class="text">{{$t('User.preciousMetalLeverage')}}<el-tooltip popper-class="maxwidthtooltips" class="item" effect="dark" :content="$t('User.accountCardTips2')" placement="top">
          <i class="el-icon-info icon-el iconcolor"></i>
        </el-tooltip>:</span>
        <span class="data" v-if="accountInfo.businessType != 5">
          1:{{accountInfo.preciousMetalLeverage||accountInfo.preciousMetalLeverage == 0?accountInfo.preciousMetalLeverage:""}}
        </span>
        <span class="data" v-else>
          1:100
        </span>
      </el-col>
      <el-col :span="24" class="xs-line">
        <span class="text">{{$t('User.liquidationRatio')}}<el-tooltip popper-class="maxwidthtooltips" class="item" effect="dark" :content="$t('User.accountCardTips3')" placement="top">
          <i class="el-icon-info icon-el iconcolor"></i>
        </el-tooltip>:</span>
        <span class="data" v-if="accountInfo.businessType != 5">
          {{accountInfo.forceClosedRate||accountInfo.forceClosedRate == 0?accountInfo.forceClosedRate+'%':""}}
        </span>
        <span class="data" v-else>
          100%
        </span>
      </el-col>
      <el-col :span="24" class="xs-line">
        <span class="text">{{$t('User.collateralMarginRatio')}}<el-tooltip popper-class="maxwidthtooltips" class="item" effect="dark" :content="$t('User.accountCardTips4')" placement="top">
          <i class="el-icon-info icon-el iconcolor"></i>
        </el-tooltip>:</span>
        <span class="data" v-if="accountInfo.businessType != 5">
          {{accountInfo.lockedMarginRate||accountInfo.lockedMarginRate == 0?accountInfo.lockedMarginRate+'%':""}}
        </span>
        <span class="data" v-else>
          50%
        </span>
      </el-col>
      <el-col :span="12" class="xs-line">
        <span class="text">
          {{$t('state')}}:
        </span>
        <span class="data">
          <mt4-status
            class="mt4-status"
            :account-info="accountInfo"
          ></mt4-status>
        </span>
      </el-col>



    </el-row>
  </div>
  <div class="bar-right">
    <el-button
      :disabled="isDemo"
      class="neededit-btn"
      size="size"
      @click="depositHandle"
    >{{$t('User.in')}}</el-button>
    <el-button
      :disabled="isDemo"
      class="neededit-btn"
      size="size"
      @click="withdrawHandle"
    >{{$t('User.out')}}</el-button>
    <el-button
      v-if="!(accountInfo.businessType == 5 && accountInfo.accountStatus == 1)"
      class="neededit-btn"
      size="size"
      @click="tradeHandle"
    >{{$t('trade')}}</el-button>
    <el-button
      v-else
      class="neededit-btn reactivate-btn"
      size="size"
      @click="reactivateHandle"
    >{{$t('reactivate')}}</el-button>
    <div class="setting-box" v-if="!(accountInfo.businessType == 5 && accountInfo.accountStatus == 1)">
      <account-operate
        :is-demo="isDemo"
        :account-info="accountInfo"
        @transferHandle="transferHandle"
        @leverHandle="leverHandle"
        @passwordHandle="passwordHandle"
        @accountTypeSetHandle="accountTypeSetHandle"
      ></account-operate>
    </div>
  </div>
</div>
</template>

<script>
import copy from 'copy-to-clipboard';
import accountOperate from "@/components/dashboard/accountOperate";
import { mapGetters } from 'vuex'
import mt4Status from "@/components/public/mt4Status";
import { colorRgba } from '@/utils/index.js';
import { jumpDetailsPage,getAccountType } from "@/utils/common";
export default {
  name: "accountBar",
  props: {
    accountInfo: {
      type: Object,
      default(){
        return {
          businessType: ''
        }
      }
    },
    isDemo: {
      type: Boolean,
      default: false,
    },
  },
  components:{
    mt4Status,
    accountOperate,
  },
  computed: {
    ...mapGetters(['themeColor','userInfo','realMobile']),
    themeOpacty(){
      return {
        background: colorRgba(this.themeColor,0.1),
      }
    },
    accTypeText(){
      if(this.accountInfo.businessType == 5){
        return this.$t('Demo_account');
      }else {
        return this.$t('live');
      }
    },
    currency(){
      return ' ' + this.accountInfo.currency
    }
  },
  methods: {
    getAccountType,
    copyHandle(info){
      copy(info);
      this.$message({
        type: 'success',
        message: this.$t('User.copySuccess'),
      })
    },
    detailHandle(){
      // 详情页面
      if(this.isDemo) return;
      localStorage.setItem('goBackRouterName','dashboard');
      jumpDetailsPage({
        vm: this,
        userInfo: this.userInfo,
        signalInfo: this.accountInfo,
      })
    },
    transferHandle() {
      this.$store.commit('setDepositAccount',this.accountInfo.login);
      this.$router.push({name: 'transfers'});
    },
    leverHandle(){
      this.$emit('lever-setting',this.accountInfo);
    },
    passwordHandle(){
      this.$emit('password-setting',this.accountInfo);
    },
    // 入金
    depositHandle(){
      this.$store.commit('setDepositAccount',this.accountInfo.login);
      this.$router.push({name: 'depositFunds'});
    },
    // 出金
    withdrawHandle(){
      this.$store.commit('setDepositAccount',this.accountInfo.login);
      this.$router.push({name: 'withdraw'});
    },
    // 交易
    tradeHandle(){
      this.$emit('trande-click',this.accountInfo);
    },
    // 重新激活
    reactivateHandle(){
      this.$emit('reactivate-click',this.accountInfo);
    },
    accountTypeSetHandle(){
      this.$emit('type-set',this.accountInfo);
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variable";
@media screen and (min-width: 1440px){
  .account-bar {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
  }
  .bar-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}

@media screen and (max-width: 1440px){
  .account-bar {

  }
  .bar-right {
    margin-top: 10px;
  }
}

.account-bar {
  background-color: #ffffff;
  border-radius:  5px;

  margin-bottom: 10px;
  padding: 20px 24px;
  .bar-left {
    .left-top {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 15px;
    }
    .left-bot {
      font-size: 14px;

    }
  }
  .bar-right {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .setting-box {
      margin-left: 10px;
      font-size: 14px ;
      flex: 1;
      text-align: center;
      padding: 6px 0px;
    }
  }

  .text {
    color: #B9B9C3;
  }
  .data {
    color: #6E6B7B;
  }
  .bar-bot {
    padding: 20px 16px;
    .line-box {
      margin-bottom: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      .line-box-left {
        color: #A29FAE;
      }
      .line-box-right {
        color: #5E5873;
        font-size: 14px;
      }
      .line-el {
        flex: 1;
        height: 0;
        border-bottom: 1px dashed #D8D6DE;
        margin: 0 10px;
      }
    }
  }
  .mt4-status {
    display: inline;
  }
  .reactivate-btn {
    background-color: #FE5924 !important;
    color: #ffffff !important;
    border-color: #FE5924 !important;
    &:hover {
      background-color: #FE5924 !important;
      color: #ffffff !important;
      border-color: #FE5924 !important;
    }
    &:focus {
      background-color: #FE5924 !important;
      color: #ffffff !important;
      border-color: #FE5924 !important;
    }
  }
}
// 移动端样式
@media screen and (max-width: 768px){
  .account-bar {
    .bar-right {
      margin-top: 10px;
    }
    .pc-left-bot {
      display: none;
    }
  }
}
// pc端样式
@media screen and (min-width: 768px){
  .xs-line {
    display: none;
  }
}
</style>
<style lang="scss">
.account-bar {
}
</style>
